export enum CollectTrackingResultType {
    Failed = -1,
    PendingSystem = 0,
    PendingUser = 1,
    Success = 2
}